export default __webpack_public_path__ + "static/media/compline-logo.0e6fe2af.svg";